import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '../../primitives';
import { rem } from 'polished';

const StyledSocialbar = styled.nav(
  ({ color }: { color?: string }) => css`
    display: inline-flex;
    width: 100%;

    ${color &&
    css`
      svg path {
        fill: ${color};
      }
    `}
  `,
);

const StyledSocialLink = styled(Link)`
  padding: ${rem(4)};
`;

const Socialbar = ({ color }: SocialbarProps) => {
  return (
    <StyledSocialbar color={color}>
      <StyledSocialLink
        linkText="EnergieSchweiz | Facebook"
        link={{
          href: 'https://www.facebook.com/EnergieSchweiz',
          title: 'EnergieSchweiz | Facebook',
          target: '_blank',
        }}
        color="light"
        iconAfter="EchIconSocialMediaFacebook2White"
        iconSize="40"
        iconOnly
      />
      <StyledSocialLink
        linkText="EnergieSchweiz (@energieschweiz) | Instagram"
        link={{
          href: 'https://www.instagram.com/energieschweiz/',
          title: 'EnergieSchweiz (@energieschweiz) | Instagram',
          target: '_blank',
        }}
        color="light"
        iconAfter="EchIconSocialMediaInstagram2White"
        iconSize="40"
        iconOnly
      />
      <StyledSocialLink
        linkText="EnergieSchweiz | LinkedIn"
        link={{
          href: 'https://www.linkedin.com/company/energieschweiz',
          title: 'EnergieSchweiz | LinkedIn',
          target: '_blank',
        }}
        color="light"
        iconAfter="EchIconSocialMediaLinkedin2White"
        iconSize="40"
        iconOnly
      />
    </StyledSocialbar>
  );
};

export type SocialbarProps = {
  /** Class of the Socialbar */
  className?: string;
  /* Color of the icons */
  color?: string;
};

export default Socialbar;
